import React, { FC } from 'react'

const CurvyLine1: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="184"
    height="236"
    viewBox="0 0 184 236"
    fill="none"
  >
    <path
      stroke="#71757D"
      strokeDasharray="14 14"
      strokeLinecap="round"
      strokeOpacity=".5"
      strokeWidth="2"
      d="M1.5 1.5c-3 131 126.221 190.677 180.551 233.131"
    />
  </svg>
)

export default CurvyLine1
